import { render } from "./SeatInformationMobile.vue?vue&type=template&id=18638360&scoped=true"
import script from "./SeatInformationMobile.vue?vue&type=script&lang=js"
export * from "./SeatInformationMobile.vue?vue&type=script&lang=js"

import "./SeatInformationMobile.vue?vue&type=style&index=0&id=18638360&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18638360"]])

export default __exports__